import React from 'react';
import { FormattedMessage } from 'react-intl';
import Layout from '../components/en';
import SEO from '../components/seo';

const NotFoundPage = () => (
  <Layout location={typeof window !== 'undefined' ? location : null}>
    <SEO
      title="Error 404 - Furlan Snowboards"
      description="Page not found"
      pathname="/404/"
      keywords={['snowboard', 'boards', 'polyvalence']}
    />
    <div className="error404Page">
      <header className="masthead">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-lg-7 my-auto">
              <div className="header-content mx-auto">
                <h1 className="mb-3">Oups, we couldn't find the page</h1>
                <p className="lead mb-5">Get back home ?</p>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  </Layout>
);

export default NotFoundPage;
